<template>
    <section class="contact">
        <SiteHeader></SiteHeader>
         <Contactform></Contactform>
        <SiteFooter></SiteFooter>
    </section>
</template>

<script>
// @ is an alias to /src
import SiteHeader from '@/components/SiteHeader.vue'
import Contactform from '@/components/Contactform.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  components: {
      SiteHeader,
      Contactform,
      SiteFooter
  }
}
</script>
